import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation createDirectory($model: CreateDirectoryInput) {
  createDirectory(input: $model) {
    id
    name
    description
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function createDirectory(model) {
  return apollo.client.mutate({
    mutation,
    variables: { model },
  }).then((res) => ({ markers: [], ...res.data.createDirectory }));
}

export default createDirectory;
